import { ca } from '@cian/analytics';

export const trackStickyHeaderTabClick = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_tab',
    label,
    useLastProducts: true,
  });
};
